import { useContext, useMemo } from 'react';

import { SubjectsContext } from '../globalContext/subjects/subjectsProvider';
import { SAT_COURSE_ID } from '../consts/constants';

const useHasAsyncSatAccess = () => {
  const [subjectInfo] = useContext(SubjectsContext);

  return useMemo(() => {
    if (!subjectInfo?.allSubjectsList) return false;
    return subjectInfo.allSubjectsList.some(subject =>
      subject.course_id === SAT_COURSE_ID && subject.has_tribyte_subscription === true && subject.has_async_true === true
    );
  }, [subjectInfo?.allSubjectsList]);
};

export default useHasAsyncSatAccess;
